import SuperFetch from '../../../superFetch.js';

class CsQnaApi {
  /**
   *  [상품 문의 리스트] 상품 문의 리스트 요청하기
   */
  getCsQnaList = (data) => SuperFetch.post('/cs/qna/list', data);

  /**
   *  [상품 문의 리스트] 상품 문의 리스트 요청하기
   */
  getCsQnaExcelDownload = (data) => SuperFetch.post('/cs/qna/list/excel/download', data);

  /**
   *  [상품 문의 상세] 상품 문의 상세 요청하기
   */
  getCsQnaDetail = (data) => SuperFetch.post('/cs/qna/detail', data);

  /**
   *  [상품 문의 상세] 유저의 다른 문의 내역 요청하기
   */
  getCsUsersOtherQnaList = (data) => SuperFetch.post('/cs/qna/detail/users/other/list', data);

  /**
   *  [상품 문의 상세] 상품 문의 상태 변경 요청하기
   */
  updateCsQnaStatus = (data) => SuperFetch.post('/cs/qna/detail/update/status', data);

  /**
   *  [상품 문의 상세] 상품 문의 비밀글 여부 변경 요청하기
   */
  changeQnaSecret = (data) => SuperFetch.post('/cs/qna/detail/update/secret', data);

  /**
   *  [상품 문의 상세] 상품 문의 답변 요청하기
   */
  replyCsQnaDetail = (data) => SuperFetch.post('/cs/qna/detail/reply', data);
}

export default new CsQnaApi();
